<template>
  <div class="linkedin-simulation">
    <transition name="slide">
      <div
        class="entry"
        v-if="!corrupt"
      >
        <figure class="figure">
          <img
            :src="linkedInNormal"
            alt=""
            draggable="false"
            class="image"
            width="108"
            height="108"
          />
        </figure>
        <div class="content">
          <p class="description">
            <b class="b">Feliciteer Imane Yilmaz</b> met haar nieuwe functie. 🎉
          </p>
          <button
            class="button"
            @click="corruption = true"
            :class="corruptionClasses"
          >
            Feliciteer
          </button>
        </div>
      </div>
    </transition>
    <div class="behind">
      <figure class="figure">
        <img
          :src="linkedInDepressed"
          alt=""
          draggable="false"
          class="image"
          width="108"
          height="108"
        />
      </figure>
      <div class="content content--corrupt">
        <transition name="description">
          <p
            class="description description--corrupt"
            v-if="corrupt"
          >
            Wanneer krijg ik nou eens een fatsoenlijke baan?
          </p>
        </transition>
        <button
          class="button button--corrupt"
        >
          Gefeliciteerd!
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import media from '@/utils/media'
import { mediaQueryMixin } from '@/mixins'
import { trackSocialSimulation } from '@/utils/track'

export default {
  name: 'LinkedInSimulation',
  data () {
    return {
      corrupt: false,
      corruption: false
    }
  },
  mixins: [mediaQueryMixin],
  methods: {
    imgSize () {
      return this.mobile ? 'mobile' : 'desktop'
    }
  },
  watch: {
    corruption () {
      trackSocialSimulation('linkedin')
      setTimeout(() => {
        this.corrupt = true
      })
    }
  },
  computed: {
    linkedInNormal () {
      return media.social.linkedInNormal[this.imgSize()]
    },
    linkedInDepressed () {
      return media.social.linkedInDepressed[this.imgSize()]
    },
    corruptionClasses () {
      return {
        'button--corruption': this.corruption
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.linkedin-simulation {
  border-radius: 10px;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);
  position: relative;
  text-align: center;
  margin: 80px auto 0;
  overflow: hidden;
}
.figure {
  padding-top: 33px;
  padding-bottom: 20px;
  position: relative;
  z-index: 20;
}
.image {
}
.content {
  overflow: hidden;
  line-height: 1.5;
  font-size: 18px;
  height: 150px;
  padding-left: 27px;
  padding-right: 27px;

  @media (min-width: 768px) {
    height: 133px;
  }
}
.b {
  font-weight: $fw-semi;
}
.description {
  position: relative;
  z-index: 2;
  height: 70px;

  @media (min-width: 768px) {
    height: 45px;
  }

  &--corrupt {
    transition: all 1600ms ease-in-out 3200ms;
    transition-property: opacity, transform;
    will-change: opacity, transform;
  }
}
.description-enter, .description-leave-to {
  opacity: 0;
  transform: translateY(5px);
}
@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(#5667C6, 0.7);
  }
  70% {
    box-shadow: 0 0 0 25px rgba(#5667C6, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(#5667C6, 0);
  }
}
@keyframes corruptButton {
  from {
    transform: scale(1);
  }
  35% {
    transform: scale(1.33);
  }
  75% {
    transform: scale(1);
    background-color: white;
    color: #5667C6;
  }
  100% {
    background-color: #5667C6;
    color: white;
  }
}
.button {
  color: #5667C6;
  font-size: 20px;
  font-weight: $fw-semi;
  border-radius: 27.5px;
  min-width: 226px;
  line-height: 1;
  background-color: white;
  border: 1px solid #5667C6;
  outline: 0;
  cursor: pointer;
  padding: 17px 0px;
  position: relative;
  z-index: 20;
  animation: pulse 2s infinite;

  &--corruption {
    cursor: default;
    animation: corruptButton 1600ms forwards;
  }
  &--corrupt {
    color: white;
    border-color: white;
    opacity: 0.3;
    cursor: default;
    background-color: transparent;
    animation: none;
  }
}
.behind {
  position: relative;
  z-index: 1;
  background-color: #535252;
  color: white;

  &:before {
    content: '';
    position: absolute;
    background-image: url(~@/assets/images/blob.png);
    background-size: 485px 331px;
    width: 485px;
    height: 331px;
    background-repeat: no-repeat;
    background-position: top left;
    z-index: 1;
    right: -200px;
    bottom: -100px;
  }
}
.entry {
  position: absolute;
  z-index: 10;
  top: 0;
  top: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  background-color: white;
  transition: all 600ms ease-in-out 2200ms;
  border-radius: 10px;
  opacity: 1;
  transform-origin: 100% 100%;
  color: $c-dark;
}
.slide-enter, .slide-leave-to {
  opacity: 0;
  transform: translate(15px, -15px) rotate(4deg);
}
</style>



// WEBPACK FOOTER //
// src/components/social/LinkedInSimulation.vue